import React from "react";
import { Paper, Typography } from "@mui/material";
import aiChatMessageStyles from "./aiChatMessageStyles";
import { AiChatMessage as AiChatMessageType } from "../../types/AIChat/AiChatMessage";
import PendingExecutionJobCard from "./ExecutionJob/PendingExecutionJobCard";
import CompletedExecutionJob from "./ExecutionJob/CompletedExecutionJob";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";

type AiChatMessageProps = {
  message: AiChatMessageType;
  animated?: boolean;
};

export default function AiChatMessage({message}: AiChatMessageProps) {

  if (message.role === "user") {
    return (
      <Paper
        variant={"outlined"}
        sx={{
          ...aiChatMessageStyles.message,
          ...aiChatMessageStyles.humanMessage,
        }}
      >
        <Typography>{message.content}</Typography>
      </Paper>
    );
  }

  return (
    <>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{message.content}</ReactMarkdown>
      {message?.executionJob?.status === "pendingApproval" && (
        <PendingExecutionJobCard executionJob={message.executionJob} />
      )}
      {message?.executionJob?.status === "completed" && <CompletedExecutionJob executionJob={message.executionJob} />}
    </>
  );
};
